exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".restore-button{background-color:#fdf3e6;border:2px solid #2440ae;color:#2440ae;padding:10px 20px;text-align:center;text-decoration:none;display:inline-block;font-size:16px;width:225px;height:50px;font-weight:700;border-radius:12px;cursor:pointer;transition:background-color .3s,color .3s;margin-left:-150px}.restore-button:hover{background-color:#e6e6e6;color:#2440ae}@media (max-width:1560px){.restore-button{position:absolute;left:70%}}@media (max-width:768px){.restore-button{width:80%;font-size:14px}}@media (max-width:480px){.restore-button{width:100%;font-size:12px}}", ""]);

// exports
